(() => {
  const ROOT_SELECTOR = '.fw-portfolio-page[data-fw-card-page]';

  const initRoot = (root) => {
    if (!root || root.dataset.fwPortfolioReady === 'true') return;

    root.dataset.fwPortfolioReady = 'true';

    const filterWrapper = root.querySelector('[data-fw-portfolio-filters]');
    const groups = Array.from(root.querySelectorAll('[data-fw-card-variant-group]'));
    const slots = Array.from(root.querySelectorAll('[data-fw-nav-card-slot]'));
    const hoverQuery = window.matchMedia('(hover: hover) and (pointer: fine) and (min-width: 901px)');
    const hoverDelay = Number(root.dataset.fwHoverDelay || 400);
    const truncate = root.dataset.fwTruncate === 'true';

    let hoverTimer = null;
    let activeSlot = null;
    let resizeTimer = null;

    const clearHoverTimer = () => {
      if (hoverTimer !== null) {
        window.clearTimeout(hoverTimer);
        hoverTimer = null;
      }
    };

    const resetEdgeClasses = (slot) => {
      slot.classList.remove('is-edge-left', 'is-edge-right');
    };

    const setEdgeClasses = (slot) => {
      resetEdgeClasses(slot);

      const rect = slot.getBoundingClientRect();
      const expansionAllowance = 48;

      if (rect.left < expansionAllowance) {
        slot.classList.add('is-edge-left');
      }

      if (window.innerWidth - rect.right < expansionAllowance) {
        slot.classList.add('is-edge-right');
      }
    };

    const collapse = (slot) => {
      if (!slot) return;

      slot.classList.remove('is-expanded');
      slot.style.removeProperty('height');
      resetEdgeClasses(slot);

      if (activeSlot === slot) {
        activeSlot = null;
      }

      if (!activeSlot) {
        root.classList.remove('has-expanded-card');
      }
    };

    const collapseAll = () => {
      clearHoverTimer();
      slots.forEach(collapse);
    };

    const expand = (slot) => {
      if (!hoverQuery.matches || !slot || slot.hidden || slot.dataset.fwExpandable !== 'true' || slot.classList.contains('is-expanded')) return;

      if (activeSlot && activeSlot !== slot) {
        collapse(activeSlot);
      }

      const currentHeight = slot.getBoundingClientRect().height;
      slot.style.height = `${Math.ceil(currentHeight)}px`;
      setEdgeClasses(slot);
      slot.classList.add('is-expanded');
      activeSlot = slot;
      root.classList.add('has-expanded-card');
    };

    const visibleSlots = (group) => Array.from(
      group.querySelectorAll('[data-fw-nav-card-slot]:not([hidden])')
    );

    const equalizeTruncatedGroups = () => {
      slots.forEach((slot) => slot.style.removeProperty('min-height'));

      if (!truncate) return;

      groups.forEach((group) => {
        const groupSlots = visibleSlots(group);
        let maxHeight = 0;

        groupSlots.forEach((slot) => {
          const card = slot.querySelector('[data-fw-nav-card]');
          if (!card) return;

          maxHeight = Math.max(maxHeight, card.getBoundingClientRect().height);
        });

        if (maxHeight > 0) {
          groupSlots.forEach((slot) => {
            slot.style.minHeight = `${Math.ceil(maxHeight)}px`;
          });
        }
      });
    };

    const updateGroupVisibility = () => {
      groups.forEach((group) => {
        const hasVisibleCards = visibleSlots(group).length > 0;
        group.hidden = !hasVisibleCards;
      });
    };

    const refresh = () => {
      collapseAll();
      updateGroupVisibility();
      equalizeTruncatedGroups();
    };

    slots.forEach((slot) => {
      slot.addEventListener('pointerenter', () => {
        clearHoverTimer();
        if (!hoverQuery.matches || slot.hidden || slot.dataset.fwExpandable !== 'true') return;

        hoverTimer = window.setTimeout(() => {
          expand(slot);
          hoverTimer = null;
        }, hoverDelay);
      });

      slot.addEventListener('pointerleave', () => {
        clearHoverTimer();
        collapse(slot);
      });

      slot.addEventListener('focusin', () => {
        clearHoverTimer();
        expand(slot);
      });

      slot.addEventListener('focusout', (event) => {
        if (!slot.contains(event.relatedTarget)) {
          collapse(slot);
        }
      });
    });

    if (filterWrapper) {
      const buttons = Array.from(filterWrapper.querySelectorAll('button[data-filter]'));

      buttons.forEach((button) => {
        button.addEventListener('click', () => {
          const filter = button.dataset.filter;

          buttons.forEach((item) => {
            const isActive = item === button;
            item.classList.toggle('is-active', isActive);
            item.setAttribute('aria-pressed', isActive ? 'true' : 'false');
          });

          slots.forEach((slot) => {
            const matches = filter === 'all' || slot.dataset.category === filter;
            slot.hidden = !matches;
          });

          refresh();
        });
      });
    }

    root.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && activeSlot) {
        clearHoverTimer();
        collapse(activeSlot);
      }
    });

    root.querySelectorAll('img').forEach((image) => {
      if (!image.complete) {
        image.addEventListener('load', equalizeTruncatedGroups, { once: true });
      }
    });

    if (document.fonts?.ready) {
      document.fonts.ready.then(equalizeTruncatedGroups);
    }

    window.addEventListener('resize', () => {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(refresh, 120);
    });

    hoverQuery.addEventListener?.('change', refresh);

    updateGroupVisibility();
    equalizeTruncatedGroups();
  };

  const initWithin = (scope = document) => {
    scope.querySelectorAll(ROOT_SELECTOR).forEach(initRoot);
  };

  document.addEventListener('DOMContentLoaded', () => initWithin());
  document.addEventListener('shopify:section:load', (event) => initWithin(event.target));
})();

(() => {
  let scrollFrame = null;

  window.addEventListener(
    'scroll',
    () => {
      if (scrollFrame !== null) return;

      scrollFrame =
        window.requestAnimationFrame(() => {
          document
            .querySelectorAll(
              '.fw-portfolio-page[data-fw-card-page]'
            )
            .forEach((root) => {
              root.classList.remove(
                'has-expanded-card'
              );

              root
                .querySelectorAll(
                  '[data-fw-nav-card-slot].is-expanded'
                )
                .forEach((slot) => {
                  slot.classList.remove(
                    'is-expanded',
                    'is-edge-left',
                    'is-edge-right'
                  );

                  slot.style.removeProperty(
                    'height'
                  );
                });
            });

          scrollFrame = null;
        });
    },
    {
      passive: true
    }
  );
})();